<selected-project-list-controller></selected-project-list-controller>
@if (
  embedData &&
  embedData.projects &&
  embedData.projects.length > 0 &&
  embedData.projects[selectedProjectIndex]
) {
  <div
    class="relative flex-none w-full py-4 px-1 flex flex-col justify-center items-center gap-4 rounded bg-gray-100"
  >
    <p class="text-gray-800 dark:text-white font-semibold text-sm lg:text-lg">Color Setting</p>
    <div class="relative w-[90%] flex flex-row justify-between items-center">
      <p class="text-gray-800 dark:text-white text-xs lg:text-base">Color Custom Active</p>
      <mat-slide-toggle [(ngModel)]="isColorChange" (ngModelChange)="onChangeIsColor()">
      </mat-slide-toggle>
    </div>
    <div
      class="relative w-[90%] min-h-16 p-2 flex flex-row flex-wrap gap-2 bg-white rounded shadow-inner"
    >
      @for (color of embedData.projects[selectedProjectIndex].colors; track color) {
        <button
          (click)="deleteColor(color)"
          class="relative flex-none w-5 h-5 rounded-full ring-3 ring-white shadow"
          [ngStyle]="{ backgroundColor: color }"
        ></button>
      }
    </div>
    <div class="relative w-[90%]" #mainDom>
      <div #boxColorPicker></div>
    </div>
    <div class="relative w-[90%] flex flex-row justify-between items-center gap-4">
      <p class="text-gray-800 dark:text-white text-xs lg:text-base">Hex</p>
      <input
        type="text"
        class="w-full px-2 py-1 rounded bg-white text-gray-800 text-center shadow-inner"
        [(ngModel)]="color"
      />
    </div>

    <button
      class="w-full flex justify-center items-center py-1 bg-[#0047FF] rounded"
      (click)="onClickColorAddBtn()"
    >
      Color Add
    </button>
  </div>
}
